// extracted by mini-css-extract-plugin
export default {"root":"Select_root__Jxsf+","button":"Select_button__qWzmo","list":"Select_list__6M2Mt"};